import React, { Component } from 'react'

class LocateAssetScreen extends Component {
  // constructor(props) {
  //   super(props);

  // }

  render() {
      return (
        <div className="animated fadeIn">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <i className="fa fa-align-justify"></i> Page under contruction
                </div>
                <div className="card-body">
                  <div className="h-60vh-c flex-row align-items-center">
                    <div className="row justify-content-center">
                      <div className="col-md-12">
                        <div className="clearfix text-center">
                          <h4 className="pt-3">Sory, This page is under contruction!</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
  }

}

export default LocateAssetScreen;


// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/asset/locate.js